/** Public site URL — override in env for staging. */
export const SITE_URL = (
    process.env.REACT_APP_SITE_URL || "https://lnsols.com"
).replace(/\/$/, "");

export const SITE_NAME = "LN Sols";

export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

export const ORG_ADDRESS = {
    streetAddress: "Hyderabad",
    addressLocality: "Hyderabad",
    addressRegion: "Telangana",
    postalCode: "500001",
    addressCountry: "IN"
};
